// PWA install detection helpers
// Detects platform/browser, install state, and exposes the deferred install prompt.

const DISMISS_KEY = 'kinsy_pwa_install_dismissed_at';
const DISMISS_TTL_DAYS = 14;

export function isStandalone() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia?.('(display-mode: standalone)').matches ||
    // iOS Safari sets navigator.standalone when launched from home screen
    window.navigator.standalone === true
  );
}

export function getPlatform() {
  if (typeof window === 'undefined') return 'unknown';
  const ua = window.navigator.userAgent || '';
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  const isAndroid = /Android/.test(ua);
  const isSafari = /^((?!chrome|crios|fxios|edgios|opios).)*safari/i.test(ua);
  const isChromium = /Chrome|CriOS|EdgA|EdgiOS|OPR/i.test(ua);

  if (isIOS && isSafari) return 'ios-safari';
  if (isIOS) return 'ios-other'; // iOS Chrome/Firefox can't install PWAs
  if (isAndroid && isChromium) return 'android-chrome';
  if (isChromium) return 'desktop-chrome';
  return 'other';
}

export function isInstallDismissed() {
  try {
    const ts = window.localStorage.getItem(DISMISS_KEY);
    if (!ts) return false;
    const ageMs = Date.now() - parseInt(ts, 10);
    return ageMs < DISMISS_TTL_DAYS * 24 * 60 * 60 * 1000;
  } catch {
    return false;
  }
}

export function markInstallDismissed() {
  try {
    window.localStorage.setItem(DISMISS_KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
}

export function clearInstallDismissed() {
  try {
    window.localStorage.removeItem(DISMISS_KEY);
  } catch {
    /* ignore */
  }
}
